import { render } from "./OtherPerDiem.vue?vue&type=template&id=5f27980b"
import script from "./OtherPerDiem.vue?vue&type=script&lang=js"
export * from "./OtherPerDiem.vue?vue&type=script&lang=js"

import "./OtherPerDiem.vue?vue&type=style&index=0&id=5f27980b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__